<div class='d-flex justify-content-center'>
    <div class='login-box'>
        <div class='login-main-text'>Login</div>
        <app-login-form></app-login-form>
    </div>
</div>
